import OAuthAuthorize, {useRoute} from './OAuthAuthorize.jsx'

export default () => {
    const overrides = useRoute()
    return {
        path: '/oauth/authorize',
        element: <OAuthAuthorize />,
        ...overrides,
    }
}
